export default __webpack_public_path__ + "static/media/koleos-gallery-1.48ab19b8.jpg";